import { useLazyQuery, useQuery } from "@apollo/client";
import { SCANS_BY_PRODUCT } from "../scans.queries";
import {
  ScansByProductQuery,
  ScansByProductQueryVariables,
} from "../../../__generated__/ScansByProductQuery";

export const useScansByProduct = (variables: ScansByProductQueryVariables) => {
  return useQuery<ScansByProductQuery, ScansByProductQueryVariables>(
    SCANS_BY_PRODUCT,
    {
      variables,
    }
  );
};
export const useLazyScansByProduct = () => {
  return useLazyQuery<ScansByProductQuery>(SCANS_BY_PRODUCT);
};
